import React from 'react'
import { useSelector } from 'react-redux'

import List from './Documents'
import Detail from './DocumentDetail'

import { getLocation } from 'ducks/router'

const getPk = (state): string | number | undefined =>
  getLocation(state).payload?.pk

const Documents = () => {
  const pk = useSelector(getPk)
  return pk ? <Detail pk={pk} /> : <List />
}

export default Documents
